import {
    IFilterOrdersSuccessAction,
    IUpdateOrderFilterSuccessAction,
} from '../actions/load-search-orders';
import { IOrderTrackerState } from '../state';
import { groupAndSortSummary } from '../methods/group-and-sort-summary-details';
import indexOf from 'lodash-es/indexOf';
import cloneDeep from 'lodash-es/cloneDeep';
import findIndex from 'lodash-es/findIndex';

export type searchOrdersAction = IFilterOrdersSuccessAction
    | IUpdateOrderFilterSuccessAction;

export const updateOrderSuccessReducer = (state: IOrderTrackerState, action: IUpdateOrderFilterSuccessAction) => {
    const updatedOrdersFilters = (action as IUpdateOrderFilterSuccessAction).data.orders.filters;
    const updatedOrdersOriginal = (action as IUpdateOrderFilterSuccessAction).data.orders.original;
    const updatedSearchString = (action as IUpdateOrderFilterSuccessAction).data.orders.searchString;
    const isInternationalUser = (action as IUpdateOrderFilterSuccessAction).data.orders.isInternational;

    return ({
        ...state,
        search: {
            ...state.search,
            orders: {
                ...state.search.orders,
                searchString: updatedSearchString !== undefined ? updatedSearchString :
                    state.search.orders.searchString,
                filters: updatedOrdersFilters !== undefined ? updatedOrdersFilters : state.search.orders.filters,
                original: updatedOrdersOriginal !== undefined ? updatedOrdersOriginal : state.search.orders.original,
                isInternational: isInternationalUser
            }
        }
    })
};

export const updateOrderDetailsSummaryFilterSuccess =
    (state: IOrderTrackerState, action: IUpdateOrderFilterSuccessAction) => {
        const updatedOrderDetailsSummaryFilters = (action as IUpdateOrderFilterSuccessAction).data.
            orderDetailsSummary.filters;
        const updatedOrderDetailsSummaryOriginal = (action as IUpdateOrderFilterSuccessAction).data.
            orderDetailsSummary.original;

        return ({
            ...state,
            search: {
                ...state.search,
                orderDetailsSummary: {
                    ...state.search.orderDetailsSummary,
                    filters: updatedOrderDetailsSummaryFilters !== undefined ? updatedOrderDetailsSummaryFilters :
                        state.search.orderDetailsSummary.filters,
                    original: updatedOrderDetailsSummaryOriginal !== undefined ? updatedOrderDetailsSummaryOriginal :
                        state.search.orderDetailsSummary.original
                }
            }
        })
    };

export const searchOrderDetailsSummarySuccessReducer = (state: IOrderTrackerState, action: searchOrdersAction) => {
    const filters = state.search.orderDetailsSummary.filters;
    const originalOrderDetails = cloneDeep(state.orderInfo.data.originalData);
    let filteredOrderDetailsSummary = [];
    let filteredOrderDetailsProgress = [];

    if (filters && filters.status && filters.status.length) {
        const statusFilter = filters.status.map((v) => v.value);
        filteredOrderDetailsProgress = originalOrderDetails.progress
            .filter((product) => indexOf(statusFilter, product.status) > -1);
    }

    if (filteredOrderDetailsProgress.length > 0) {
        filteredOrderDetailsSummary = originalOrderDetails.summary
            .filter((s) => findIndex(filteredOrderDetailsProgress, (p) => p.uuid === s.uuid) > -1)
    }

    const calculatedSummary = groupAndSortSummary(filteredOrderDetailsSummary,
        (action as IFilterOrdersSuccessAction).viewby);
    const selectedSummaryItem = Object.keys(calculatedSummary)[0];
    const selectedProduct = calculatedSummary[selectedSummaryItem]
    [Object.keys(calculatedSummary[selectedSummaryItem])[0]][0].uuid;

    return ({
        ...state,
        orderInfo: {
            ...state.orderInfo,
            data: {
                ...state.orderInfo.data,
                summary: filteredOrderDetailsSummary,
                selectedProduct,
                selectedSummaryItem,
                calculatedSummary
            }
        }
    })
};
